// composables/useSecret.ts
export const useSecret = async (keys: string[]): Promise<Record<string, string>> => {
    try {
      const { data, error } = await useFetch<Record<string, string>>('/api/get-secret', {
        method: 'POST',
        body: { keys },
      });
  
      if (error.value) {
        throw new Error(`Failed to fetch secrets: ${error.value.message}`);
      }
  
      return data.value || {};
    } catch (err) {
      console.error("Error fetching secrets from useSecret:", err);
      throw err;
    }
  };
  
 